import React, {useContext} from 'react';

import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {
    SimpleActionButton,
} from 'components/form/components';
import {RequestCardContext} from 'components/request/replies/context/request-card-context';
import {EButtonType} from 'entities/metadata';

interface ICollapseButtonProps {
    buttonType?: EButtonType;
    actionIcon?: TIconType;
}

export const CollapseButton = ({actionIcon, buttonType}: ICollapseButtonProps) => {
    const {text, handleCollapse} = useContext(RequestCardContext);
    return (
        <SimpleActionButton
            type={buttonType || 'primary'}
            onClick={handleCollapse}
            icon={actionIcon}
            title={text}
        />
    );
};
